import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';
import interviewReducer from './interviewSlice';
import configReducer from './configSlice';

// 配置持久化
const persistConfig = {
  key: 'root',
  storage,
  // 可以选择需要持久化的reducer，这里持久化所有状态
  // 如果只想持久化特定reducer，可以使用 whitelist: ['interview']
};

// 合并reducers
const rootReducer = combineReducers({
  interview: interviewReducer,
  config: configReducer,
});

// 创建持久化的reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// 创建store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // 忽略redux-persist的action
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

// 创建persistor
export const persistor = persistStore(store);

// 导出类型
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
